import { Box } from '@chakra-ui/react';

const Divider = () => {
  return (
    <Box borderBottom="1px" borderBottomColor="gray.200" my="4" mx="10"></Box>
  );
};

export default Divider;
